// Pega o valor do atributo data-end-timer
const topCounter = document.querySelector(".top-counter");
if(topCounter){
    const dataEndTimer = topCounter.getAttribute("data-end-timer");
const deadLine = new Date(dataEndTimer).getTime(); // Converte para timestamp

setInterval(() => {
  const now = new Date().getTime();
  const distance = deadLine - now;

  // Seleciona os elementos dos contadores
  let progressDays = document.querySelector("#circleProgressDays");
  let progressHours = document.querySelector("#circleProgressHours");
  let progressMinutes = document.querySelector("#circleProgressMinutes");
  let progressSecont = document.querySelector("#circleProgressSeconds");

  if (distance >= 0) {
    // Calcula dias, horas, minutos e segundos restantes
    let days = Math.floor(distance / (1000 * 60 * 60 * 24));
    let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    let seconds = Math.floor((distance % (1000 * 60)) / 1000);

    // Adiciona zero à esquerda se o valor for menor que 10
    days = days < 10 ? '0' + days : days;
    hours = hours < 10 ? '0' + hours : hours;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    seconds = seconds < 10 ? '0' + seconds : seconds;

    // Atualiza os elementos do DOM
    // document.querySelector(".day-week span").innerHTML = days;
    document.querySelector(".hours-week span").innerHTML = hours;
    document.querySelector(".minutes-week span").innerHTML = minutes;
    document.querySelector(".second-week span").innerHTML = seconds;

          // Oculta o contador de dias se for zero
          const dayContainer = document.querySelector(".day-week");
          if (parseInt(days) === 0) {
              dayContainer.classList.add("hidden"); // Adiciona a classe "hidden" para ocultar
          } else {
              dayContainer.classList.remove("hidden"); // Remove a classe "hidden" se o valor de dias não for zero
              document.querySelector(".day-week span").innerHTML = days;
          }

    // Atualiza o progresso dos circulos (caso existam)
    if (progressDays) progressDays.style.strokeDashoffset = 440 - (440 * days) / 90;
    if (progressHours) progressHours.style.strokeDashoffset = 440 - (440 * hours) / 24;
    if (progressMinutes) progressMinutes.style.strokeDashoffset = 440 - (440 * minutes) / 60;
    if (progressSecont) progressSecont.style.strokeDashoffset = 440 - (440 * seconds) / 60;

    document.querySelector(".section-topbar").classList.add("hidden-topbar");
    document.querySelector(".section-topbar-count").classList.remove("hidden-topbar");
  } else {
    // Se o tempo expirou, adicionar lógica para esconder ou manipular o contador
    document.querySelector(".section-topbar-count").classList.add("hidden-topbar"); // Classe quando o tempo expira
    document.querySelector(".section-topbar").classList.remove("hidden-topbar"); // Esconde a barra
    clearInterval(this); // Para o contador
    // Se o tempo expirou, adicionar lógica para esconder ou manipular o contador
    // document.querySelector(".top-counter").classList.add("hidden");
  }
}, 1000); // Atualiza a cada segundo

}